import { generatePath, Params } from 'react-router-dom';

export const Routes = {
  app: '/app',
  backgroundCheckBuy: '/buy-background-check',
  backgroundCheckFinish: '/finish-background-check',
  bookings: {
    id: '/bookings/:id',
    root: '/bookings',
  },
  caregiver: {
    buyBackgroundCheck: '/caregiver/buy-background-check',
    dashboard: '/caregiver/dashboard',
  },
  creditCard: '/credit-card',
  credits: '/user/:id/credits',
  feedback: '/caregiver/feedback',
  homepage: '/',
  job: {
    applicant: '/job/:id/applicant/:userId',
    id: '/job/:id',
    edit: '/job/:id/edit',
    interest: '/job/:id/interest',
  },
  login: '/login',
  parent: {
    dashboard: '/family/dashboard',
    feedback: '/parent/:id/feedback',
  },
  public: {
    aboutUs: '/about-us',
    careers: '/careers/',
    giftCards: '/gift-cards',
    privacyPolicy: '/privacy-policy',
    terms: '/terms-of-service/',
    trust: '/trust/',
  },
  referral: '/referral',
  sitter: {
    calendar: '/sitter-calendar',
    jobBoard: '/job-board',
    messages: '/sitter/:id/messages',
    notifications: '/sitter/:id/notifications',
    payout: '/sitter/payout',
    profile: '/sitter/:id',
    registration: {
      availability: '/sitter/registration/availability',
      photo: '/sitter/registration/photo',
      worksWith: '/sitter/registration/works-with',
    },
    stats: '/sitter/:id/stats',
    settings: '/sitter/:id/settings',
    successGuide: '/sitter/success-guide',
    yourFamilies: '/sitter/:id/your-families',
    video: '/sitter/video',
  },
  support: 'https://support.urbansitter.com/',
  user: {
    creditCard: '/user/:id/credit-card',
  },
  transactions: '/transactions',
};

export const getUrlFromPath = (route: string, params?: Params<string> | undefined): string => `/app${generatePath(route, params)}`;
